import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Minisite.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Minisite extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    publish({ organizationId, schedule } = {}) {
        let data = schedule && schedule !== 'withEvent' ? { date: schedule.toISOString() } : {};
        let url = `${this.constructor.listUrl({ organizationId })}/${this.pk}/publish`;
        return BaseAPIModel.fetcher.post(url, { data });
    }

    unpublish({ organizationId } = {}) {
        let url = `${this.constructor.listUrl({ organizationId })}/${this.pk}/unpublish`;
        return BaseAPIModel.fetcher.post(url);
    }

    generate({ organizationId, eventId } = {}) {
        if (!organizationId || !eventId) {
            throw new ArgumentError('[Model][Minisite] organizationId & eventId are mandatory');
        }
        return BaseAPIModel.fetcher
            .post(`/sites/organizations/${organizationId}/auto/event`, {
                data: {
                    event: eventId,
                    schedule: true
                }
            })
            .then(response => response.json());
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Minisite] organizationId is mandatory');
        }
        return `/sites/organizations/${organizationId}/sites`;
    }
}
